import * as React from 'react';
import { t } from 'i18next';

import { BaseComponent } from './BaseComponent';
import { PersistentStore } from '../stores/PersistentStore';
import { UrlHelper } from '../utils/UrlHelper';
import { PersistentActions } from '../actions/PersistentActions';
import { UICoreButton } from './UICoreButton';
import { getEnvVar } from '../submodules/utils/ReactScriptHelper';

export interface CookieBannerProps extends React.Props<CookieBanner> {
}

export interface CookieBannerState {
    hide: boolean;
    language: string | null;
}

const showCookieBanner: boolean = getEnvVar('COOKIE_BANNER', 'false') === 'true';

export class CookieBanner extends BaseComponent<CookieBannerProps, CookieBannerState> {
    public componentWillMount(): void {
        this.addStoreListener(PersistentStore, this.onChange);
        this.onChange();
    }

    public render(): JSX.Element | null {
        if (this.state.hide) {
            return null;
        }
        return (
            <div className="cookie-banner">
                <div className="cookie-banner-text">
                    <div>{t('This website uses cookies to improve user experience.')}</div>
                    {this.infoLine()}
                </div>
                <div className="cookie-banner-button">
                    <UICoreButton color="green" align="right" onClick={this.accept} label={t('Ok')}/>
                </div>
            </div>
        );
    }

    protected infoLine = (): JSX.Element => {
        const infoLine: string = t('By using our website you consent to all cookies in accordance with our {{ CookiePolicyLink }}.', {
            context: '{{ CookiePolicyLink }} will be replaced by a link to legal informations labeled with translation of \'Cookie Policy\'',
            CookiePolicyLink: '##LINK##'
        });
        const textMatch: RegExpExecArray | null = /(.*)##LINK##(.*)/.exec(infoLine);
        if (textMatch != null && textMatch.length === 3) {
            return (
                <div>
                    <span>{textMatch[1]}</span>
                    <a className="cookie-banner-link" target="_blank" href={UrlHelper.getImprintLink(this.state.language)}>{t('Cookie Policy')}</a>
                    <span>{textMatch[2]}</span>
                </div>
            );
        }
        return (
            <div>
                <a target="_blank" href={UrlHelper.getImprintLink(this.state.language)}>{infoLine}</a>
            </div>
        );
    };

    protected accept = (): void => {
        PersistentActions.acceptCookie('true');
    };

    protected onChange = (): void => {
        this.setState({
            hide: PersistentStore.getState().cookieAccepted === 'true' || !showCookieBanner,
            language: PersistentStore.getState().language
        });
    };
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/CookieBanner.tsx